//npm
import { CommonModule } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
// baayclubs moduless
import { UtilsModule } from '@bayclubs/utils';

// application modules
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DropDownModule } from '@bayclubs/drop-down';
//components
import { AgePickerComponent } from './components/age-picker/age-picker.component';
import { AmountPickerComponent } from './components/amount-picker/amount-picker.component';
import { DatePickerMultiselectComponent } from './components/date-picker-multiselect/date-picker-multiselect.component';
import { DatesSelectorComponent } from './components/dates-selector/dates-selector.component';
import { GoBackComponent } from './components/go-back/go-back.component';
import { InfoComponent } from './components/info/info.component';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';

//services
import { InfoService } from './components/info/info.service';
import { CampsSecurityService } from './services/camps-security.service';
//directives
import { BootstrapControlDirective } from './directives/boostrap-control.directive';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { ScaleVerticallyDirective } from './directives/scale-vertically.directive';
//pipes
import { ReplaceIfEmptyPipe } from './pipes/replace-if-empty.pipe';
//application providers
import { WindowRef } from './providers/window.provider';
// api
import { ApiHttpClient } from './services/api/api-http-client';
import { CampsPriviligesApiService } from './services/api/camps-priviliges-api.service';

import { AppSessionService } from './services/app-session.service';
import { GlobalErrorHandler } from './services/error.handler';

import { ValidationService } from './services/validation.service';
import { BcShowIfPrivilegeDynamicDirective } from './directives/bc-show-if-privilege-dynamic.directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { TestIdDirective } from '@bayclubs/horizon';

@NgModule({
    imports: [
        CommonModule,
        UtilsModule,
        TranslateDirective,
        TranslatePipe,
        FormsModule,
        DropDownModule,
        NgxMaskDirective,
        TestIdDirective,
    ],
    declarations: [
        BootstrapControlDirective,
        ScaleVerticallyDirective,
        NumbersOnlyDirective,
        AgePickerComponent,
        DatePickerMultiselectComponent,
        GoBackComponent,
        DatesSelectorComponent,
        InfoComponent,
        ReplaceIfEmptyPipe,
        AmountPickerComponent,
        ConfirmationModalComponent,
        BcShowIfPrivilegeDynamicDirective,
    ],
    providers: [
        ApiHttpClient,
        AppSessionService,
        WindowRef,
        CampsSecurityService,
        CampsPriviligesApiService,
        InfoService,
        ValidationService,
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        provideNgxMask()
    ],
    exports: [
        BootstrapControlDirective,
        ScaleVerticallyDirective,
        NumbersOnlyDirective,
        AgePickerComponent,
        DatePickerMultiselectComponent,
        GoBackComponent,
        DatesSelectorComponent,
        ReplaceIfEmptyPipe,
        AmountPickerComponent,
        BcShowIfPrivilegeDynamicDirective
    ]
})
export class InfrastructureModule {}

//components
export { AgePickerComponent } from './components/age-picker/age-picker.component';
export { AmountPickerComponent } from './components/amount-picker/amount-picker.component';
export { DatePickerMultiselectComponent } from './components/date-picker-multiselect/date-picker-multiselect.component';
export { GoBackComponent } from './components/go-back/go-back.component';
//services
export { InfoService } from './components/info/info.service';
//directives
export { BootstrapControlDirective } from './directives/boostrap-control.directive';
export { NumbersOnlyDirective } from './directives/numbers-only.directive';
export { ScaleVerticallyDirective } from './directives/scale-vertically.directive';
export { cenum } from './models/enums.generated';
export { c } from './models/models.generated';
//services
export { ApiHttpClient } from './services/api/api-http-client';
export { CampsPriviligesApiService } from './services/api/camps-priviliges-api.service';
export { AppSessionService } from './services/app-session.service';
export { CampsSecurityService } from './services/camps-security.service';
export { ValidationService } from './services/validation.service';
